import { render, staticRenderFns } from "./OverdueIndicator.vue?vue&type=template&id=88f483ce"
import script from "./OverdueIndicator.vue?vue&type=script&lang=js"
export * from "./OverdueIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports